@if (briefing) {
    @if(briefing.deliveryMethod === deliveryMethods.ONLINE) {
        <div class="agpr-briefingPublishingStep-online-sectionContainer">
            <div class="agpr-briefingPublishingStep-sectionLabel">
                {{ 'Briefings.setUpPublishing.canvasName' | localize}}
                <span
                    id="briefing_canvasName_info"
                    class="fa-regular fa-circle-info agpr-briefingPublishingStep-optionHeader-info"
                    [agprTooltip]="'Briefings.setUpPublishing.canvasName.tooltip'">
                </span>
            </div>
            <div class="agpr-inputGroup">
                <agpr-text-input
                    [id]="'canvasNameInput'"
                    [maxLength]="maxInputTextLength"
                    [placeholder]="'Briefings.setUpPublishing.canvasName.placeholder' | localize"
                    [(ngModel)]="briefing.subject"
                    (ngModelChange)="briefingChanged()"
                    [bottomMargin]="false"
                    [ariaInvalid]="showErrors && (!briefing.subject || briefing.subject.trim() === '')"
                    ariaDescribedBy="canvasName_errors"
                ></agpr-text-input>
            </div>
            @if (showErrors && (!briefing.subject || briefing.subject.trim() === '')) {
                <agpr-form-message
                    [id]="'canvasName_errors'"
                    class="agpr-briefingError"
                >
                    {{ 'Briefings.setUpPublishing.canvasName.error' | localize }}
                </agpr-form-message>
            }
        </div>
    }

    <div class="agpr-briefingPublishingStep-scheduler">
        <div class="agpr-briefingPublishingStep-sectionLabel">
            {{'Briefings.sidebar.headingScheduling' | localize }}
        </div>
        @if (requireAutomaticInsightGen && (deliverySchedulerInputFields.schedulingType === deliveryTypes.immediate)) {
            <agpr-message
                [severity]="messageSeverityEnum.info"
            >
                {{ 'Briefings.blockType.autoGeninsights.sendNow.infoMessage' | localize }}
            </agpr-message>
        }
        <agpr-delivery-scheduler
            #deliveryScheduler
            [inputId]="id + '-deliveryScheduler'"
            [messages]="deliverySchedulerMessages"
            [(deliveryDate)]="deliverySchedulerInputFields.deliveryDate"
            [(time)]="deliverySchedulerInputFields.deliveryTime"
            [recurringModel]="deliverySchedulerInputFields.recurrenceModel"
            [minDate]="deliverySchedulerInputFields.minDate"
            [immediateOptionLabel]="'Briefings.input.publishNow' | localize"
            [futureOptionLabel]="'Briefings.input.publishLater' | localize"
            [recurringOptionLabel]="'Briefings.input.publishRecurring' | localize"
            [showRecurring]=true
            [minDateValidationMessage]="'Briefings.error.minDateTooEarly' | localize"
            [(selectedSchedulingType)]="deliverySchedulerInputFields.schedulingType"
            (recurrencePatternChanged)="updateRecurringPattern($event)"
            (selectedSchedulingTypeChange)="selectedSchedulingTypeChanged($event)"
            (deliveryDateChange)="deliveryDateChanged($event)"
            (timeChange)="timeChange($event)"
            [disableSendNow]="briefing.hasBeenSent"
            [disableSendLater]="briefing.hasBeenSent"
            [disabledTooltip]="briefing.hasBeenSent ? 'Briefings.sidebar.recurring.hasBeenSent.tooltip' : ''"
        ></agpr-delivery-scheduler>
        @if (deliverySchedulerInputFields.schedulingType === deliveryTypes.recurring) {
            <div class="agpr-briefing-sidebar-mentionTimeFrameWrapper">
                <div class="agpr-briefing-sidebar-mentionTimeFrame">
                    {{ 'Briefings.sidebar.mentionTimeFrame' | localize }}
                </div>
                <div
                    class="agpr-briefing-sidebar-mentionTimeFrameOptions"
                >
                    <agpr-radio
                        [id]="id + '.mentionTimeFrame-0'"
                        class="agpr-briefing-sidebar-mentionTimeFrameOption"
                        [value]="false"
                        label="Briefings.sidebar.mentionTimeFrame.sinceLastBriefing"
                        hiddenLabel="Briefings.sidebar.mentionTimeFrame.sinceLastBriefing"
                        [(ngModel)]="briefing.sendAt.allowPastContent"
                        (ngModelChange)="briefingChanged()"
                        [tooltip]="'Briefings.sidebar.mentionTimeFrame.sinceLastBriefing.toolTip' | localize"
                    ></agpr-radio>
                    <agpr-radio
                        [id]="id + '.mentionTimeFrame-1'"
                        class="agpr-briefing-sidebar-mentionTimeFrameOption"
                        [value]="true"
                        label="Briefings.sidebar.mentionTimeFrame.basedOnMentionBlockSetting"
                        hiddenLabel="Briefings.sidebar.mentionTimeFrame.basedOnMentionBlockSetting"
                        [(ngModel)]="briefing.sendAt.allowPastContent"
                        (ngModelChange)="briefingChanged()"
                        [tooltip]="'Briefings.sidebar.mentionTimeFrame.basedOnMentionBlockSetting.toolTip' | localize"
                    ></agpr-radio>
                </div>
            </div>
            <agpr-checkbox
                [id]="id + '_otherSettings_sendEmpty'"
                class="agpr-briefing-sidebar-otherSettingsCheckbox"
                [binary]="true"
                label="Briefings.otherSettings.sendEmpty"
                infoCircleTooltip="Briefings.otherSettings.sendEmpty.tooltip"
                [(ngModel)]="briefing.sendRecurringBriefingWhenMentionsEmpty"
                (onChange)="briefingChanged()"
            ></agpr-checkbox>
        }
    </div>
    @if(briefing.deliveryMethod === deliveryMethods.EMAIL) {
        <ul class="agpr-briefingPublishingStep">
            <li class="agpr-briefingPublishingStep-option ">
                <div class="agpr-briefingPublishingStep-optionHeader">
                    <agpr-checkbox
                        [id]="'deliveryOptions_email'"
                        [binary]="true"
                        [(ngModel)]="briefing.selectedDeliveryOption.email"
                        (onChange)="deliveryOptionChanged($event, deliveryOptionsEnum.email)"
                        ariaDescribedBy="deliveryOption_error"
                    ></agpr-checkbox>
                    <span
                        class="fa-regular fa-duotone fa-envelope agpr-briefingPublishingStep-optionHeader-icon"
                    ></span>
                    <h4 class="agpr-briefingPublishingStep-optionHeader-title agpr-briefingPublishingStep-email-sectionHeader" >{{ 'Briefings.deliveryOptions.email' | localize }}</h4>
                </div>
                @if (!briefing.selectedDeliveryOption.email) {
                    <div class="agpr-briefingPublishingStep-optionDescription">
                        {{ 'Briefings.deliveryOptions.email.description' | localize }}
                    </div>
                } @else {
                    <div class="agpr-briefingPublishingStep-optionInputs">
                        <div class="agpr-inputGroup">
                            <agpr-text-input
                                [id]="'subjectLineTextInput'"
                                [placeholder]="'Briefings.input.subjectLine.placeholder' | localize"
                                [label]="'Briefings.input.subjectLine'"
                                [maxLength]="maxInputTextLength"
                                [(ngModel)]="briefing.subject"
                                (ngModelChange)="briefingChanged()"
                                [bottomMargin]="false"
                                [ariaInvalid]="showErrors && (!briefing.subject || briefing.subject.trim() === '')"
                                ariaDescribedBy="subject_errors"
                            ></agpr-text-input>

                        </div>
                        @if (showErrors && (!briefing.subject || briefing.subject.trim() === '')) {
                            <agpr-form-message
                                [id]="'subject_errors'"
                                class="agpr-briefingError"
                            >
                                {{ 'Briefings.input.subjectLine.validation' | localize }}
                            </agpr-form-message>
                        }
                        <div class="agpr-inputGroup">
                            <agpr-text-input
                                [id]="'previewTextInput'"
                                [label]="'Briefings.input.previewText'"
                                [tooltip]="'Briefings.input.previewText.tooltip'"
                                [placeholder]="'Briefings.input.previewText.placeholder'"
                                maxLength="90"
                                [(ngModel)]="briefing.previewText"
                                (ngModelChange)="briefingChanged()"
                                [bottomMargin]="false"
                            ></agpr-text-input>
                        </div>
                        <div class="agpr-inputGroup">
                            <agpr-text-input
                                [id]="'fromTextInput'"
                                [maxLength]="maxInputTextLength"
                                [placeholder]="'Briefings.input.fromName.placeholder' | localize"
                                [label]="'Briefings.input.fromName'"
                                [(ngModel)]="briefing.fromName"
                                (ngModelChange)="briefingChanged()"
                                [bottomMargin]="false"
                                [ariaInvalid]="showErrors && (!briefing.fromName || briefing.fromName.trim() === '')"
                                ariaDescribedBy="fromName_errors"
                            ></agpr-text-input>
                        </div>
                        @if (showErrors && (!briefing.fromName || briefing.fromName.trim() === '')) {
                            <agpr-form-message
                                [id]="'fromName_errors'"
                                class="agpr-briefingError"
                            >
                                {{ 'Briefings.input.fromName.validation' | localize }}
                            </agpr-form-message>
                        }
                        <div class="agpr-inputGroup">
                            <agpr-text-input
                                [id]="'replyToTextInput'"
                                [maxLength]="maxInputTextLength"
                                [placeholder]="'Briefings.input.replyTo.placeholder' | localize"
                                [label]="'Briefings.input.replyTo'"
                                [(ngModel)]="briefing.replyTo"
                                (ngModelChange)="replyToChanged()"
                                (clickOutside)="setErrorList()"
                                (blur)="setErrorList()"
                                [attachOutsideOnClick]="true"
                                [bottomMargin]="false"
                                [ariaInvalid]="showErrors && (!briefing.replyTo || briefing.replyTo.trim() === '' || replyToInvalid)"
                                ariaDescribedBy="replyTo_errors"
                            ></agpr-text-input>
                        </div>
                        @if (showErrors && (!briefing.replyTo || briefing.replyTo.trim() === '' || replyToInvalid)) {
                            <ul
                                id="replyTo_errors"
                                class="agpr-briefingError"
                            >
                                @if (!briefing.replyTo || briefing.replyTo.trim() === '') {
                                    <li>
                                        <agpr-form-message>
                                            {{ 'Briefings.input.replyTo.validation' | localize }}
                                        </agpr-form-message>
                                    </li>
                                }

                                @if (replyToInvalid) {
                                    <li>
                                        <agpr-form-message>
                                            {{ 'invalidEmailFormat' | localize }}
                                        </agpr-form-message>
                                    </li>
                                }
                            </ul>
                        }
                        <div class="agpr-briefingPublishingStep-divider"></div>
                        <div class="agpr-inputGroup">
                            <label for="mailingLists.picker" class="agpr-briefing-inputLabel">
                                {{ 'Briefings.input.mailingLists' | localize }}
                            </label>
                            <agpr-mailing-list-picker
                                [(ngModel)]="briefing.mailingListIds"
                                (ngModelChange)="setBriefing()"
                                ariaDescribedBy="mailing_list_errors recipient_errors"
                                [ariaInvalid]="showErrors && mailingListError"
                            ></agpr-mailing-list-picker>
                            @if(showErrors && mailingListError) {
                                <agpr-form-message
                                    id="mailing_list_errors"
                                    class="agpr-briefingError"
                                >
                                    {{ 'Briefings.input.mailingLists.validation' | localize }}
                                </agpr-form-message>
                            }
                        </div>
                        <div class="agpr-inputGroup">
                            <agpr-email-chips
                                [id]="'recipientList'"
                                [(value)]="briefing.recipientList"
                                [placeholder]="'Briefings.input.recipients.placeholder' | localize"
                                clearAllChipsTooltip="Briefings.input.recipients.clearAllTooltip"
                                [errorKey]="'invalidEmailFormat' | localize"
                                header="Briefings.input.recipients"
                                (valueChange)="briefingChanged()"
                                ariaDescribedBy="recipient_errors"
                                [ariaInvalid]="showErrors && briefing?.recipientList?.length === 0 && briefing?.mailingListIds?.length === 0"
                            ></agpr-email-chips>
                        </div>
                        @if (showErrors && briefing?.recipientList?.length === 0 && briefing?.mailingListIds?.length === 0) {
                            <agpr-form-message
                                id="recipient_errors"
                                class="agpr-briefingError"
                            >
                                {{ 'Briefings.input.recipients.validation' | localize }}
                            </agpr-form-message>
                        }
                        <div class="agpr-briefingPublishingStep-divider"></div>
                        <div class="agpr-briefingPublishingStep-optionInputs-checkboxes">
                            <agpr-checkbox
                                *ngIf="!isRefMediaAccount"
                                id="briefing_include_insights_link"
                                label="Briefings.includeInsightsLink"
                                infoCircleTooltip="Briefings.includeInsightsLink.tooltip"
                                tooltipPosition="top"
                                [disabled]="!hasMentionInsightsEnabled || !briefing?.selectedDeliveryOption.email"
                                [(ngModel)]="briefing.includeInsightsLink"
                                [binary]="true"
                                (onChange)="insightLinkChanged()"
                                ariaDescribedBy="includeInsightsLink_error"
                                [icon]="!hasMentionInsightsEnabled ? 'fa-regular fa-duotone fa-lock fa-duotone' : ''"
                                iconTooltip="Briefings.includeInsightsLink.lockIcon.tooltip"
                            ></agpr-checkbox>
                            <agpr-checkbox
                                id="briefing_otherSettings_includeEmpty"
                                [binary]="true"
                                label="Briefings.otherSettings.includeEmpty"
                                infoCircleTooltip="Briefings.otherSettings.includeEmpty.tooltip"
                                [(ngModel)]="briefing.includeEmptyMentionSections"
                                (onChange)="includeEmptyMentionSectionsChanged()"
                            ></agpr-checkbox>
                            <agpr-checkbox
                                id="briefing_otherSettings_enableDuplicateMentions"
                                class="agpr-briefing-sidebar-otherSettingsCheckbox"
                                [binary]="true"
                                label="Briefings.otherSettings.enableDuplicateMentions"
                                infoCircleTooltip="Briefings.otherSettings.enableDuplicateMentions.tooltip"
                                [(ngModel)]="briefing.enableDuplicateMentions"
                                (onChange)="briefingChanged()"
                            ></agpr-checkbox>
                            <agpr-checkbox
                                id="briefing_otherSettings_enableMobileFormatting"
                                class="agpr-briefing-sidebar-otherSettingsCheckbox"
                                [binary]="true"
                                label="Briefings.otherSettings.enableMobileFormatting"
                                infoCircleTooltip="Briefings.otherSettings.enableMobileFormatting.tooltip"
                                [(ngModel)]="briefing.enableMobileFormatting"
                                (onChange)="briefingChanged()"
                            ></agpr-checkbox>
                            <agpr-checkbox
                                id="briefing_otherSettings_enableClickTracking"
                                class="agpr-briefing-sidebar-otherSettingsCheckbox"
                                [binary]="true"
                                label="Briefings.otherSettings.enableClickTracking"
                                infoCircleTooltip="Briefings.otherSettings.enableClickTracking.tooltip"
                                [(ngModel)]="briefing.clickTracking"
                                (onChange)="briefingChanged()"
                            ></agpr-checkbox>
                            <agpr-checkbox
                                id="briefing_otherSettings_enableOpenTracking"
                                class="agpr-briefing-sidebar-otherSettingsCheckbox"
                                [binary]="true"
                                label="Briefings.otherSettings.enableOpenTracking"
                                infoCircleTooltip="Briefings.otherSettings.enableOpenTracking.tooltip"
                                [(ngModel)]="briefing.openTracking"
                                (onChange)="briefingChanged()"
                            ></agpr-checkbox>
                        </div>
                        <ng-container *ngIf="!hasMentionInsightsEnabled && !isRefMediaAccount">
                            <agpr-mention-insight-upsell-card></agpr-mention-insight-upsell-card>
                        </ng-container>
                        <div class="agpr-briefingPublishingStep-divider"></div>
                        <ng-container *ngTemplateOutlet="reservedUrlTemplate"></ng-container>
                    </div>
                }
            </li>
            <li class="agpr-briefingPublishingStep-option agpr-briefingPublishingStep-rssFeed">
                <ng-container *ngTemplateOutlet="rssFeedOptionTemplate"></ng-container>
            </li>
        </ul>
    }

    @if(briefing.deliveryMethod === deliveryMethods.ONLINE) {
        <div class="agpr-briefingPublishingStep-online-sectionContainer">
            <div class="agpr-briefingPublishingStep-sectionLabel">
                {{ 'Briefings.setUpPublishing.publish' | localize}}
            </div>
            <div class="agpr-briefingPublishingStep-online-options">
                <agpr-checkbox
                    id="briefing_otherSettings_includeEmpty"
                    [binary]="true"
                    label="Briefings.otherSettings.includeEmpty"
                    infoCircleTooltip="Briefings.otherSettings.includeEmpty.tooltip"
                    [(ngModel)]="briefing.includeEmptyMentionSections"
                    (onChange)="includeEmptyMentionSectionsChanged()"
                ></agpr-checkbox>
                <agpr-checkbox
                    id="briefing_otherSettings_enableDuplicateMentions"
                    class="agpr-briefing-sidebar-otherSettingsCheckbox"
                    [binary]="true"
                    label="Briefings.otherSettings.enableDuplicateMentions"
                    infoCircleTooltip="Briefings.otherSettings.enableDuplicateMentions.tooltip"
                    [(ngModel)]="briefing.enableDuplicateMentions"
                    (onChange)="briefingChanged()"
                ></agpr-checkbox>
            </div>
            <div class="agpr-briefingPublishingStep-divider"></div>
            <div>
                <ng-container *ngTemplateOutlet="reservedUrlTemplate"></ng-container>
            </div>
            <!-- TODO: RSS Feed is hidden for now. Uncomment this after NEP-33196 is completed. -->
            <!-- <div class="agpr-briefingPublishingStep-divider"></div>
            <div>
                <ng-container *ngTemplateOutlet="rssFeedOptionTemplate"></ng-container>
            </div> -->
            <div class="agpr-briefingPublishingStep-divider"></div>
            <div>
                <ng-container *ngTemplateOutlet="digestOptionTemplate"></ng-container>
            </div>
        </div>
        <div class="agpr-briefingPublishingStep-online-sectionContainer delivery">
            <div class="agpr-briefingPublishingStep-sectionLabel">
                {{ 'Briefings.setUpPublishing.publishNotifications' | localize}}
            </div>

            <div class="agpr-briefingPublishingStep-optionHeader">
                <agpr-checkbox
                    [id]="'deliveryOptions_email'"
                    [binary]="true"
                    [(ngModel)]="briefing.selectedDeliveryOption.email"
                    (onChange)="deliveryOptionChanged($event, deliveryOptionsEnum.email)"
                    ariaDescribedBy="deliveryOption_error"
                ></agpr-checkbox>
                <span
                    class="fa-regular fa-duotone fa-envelope agpr-briefingPublishingStep-optionHeader-icon"
                ></span>
                <h4 class="agpr-briefingPublishingStep-optionHeader-title" >{{ 'Briefings.deliveryOptions.email' | localize }}</h4>
            </div>
            @if (!briefing.selectedDeliveryOption.email) {
                <div class="agpr-briefingPublishingStep-optionDescription">
                    {{ 'Briefings.deliveryMethod.email.description' | localize }}
                </div>
            } @else {
                <div class="agpr-briefingPublishingStep-optionInputs">
                    <div class="agpr-inputGroup">
                        <label for="mailingLists.picker" class="agpr-briefing-inputLabel">
                            {{ 'Briefings.input.mailingLists' | localize }}
                        </label>
                        <agpr-mailing-list-picker
                            [(ngModel)]="briefing.mailingListIds"
                            (ngModelChange)="setBriefing()"
                            ariaDescribedBy="mailing_list_errors recipient_errors"
                            [ariaInvalid]="showErrors && mailingListError"
                        ></agpr-mailing-list-picker>
                        @if(showErrors && mailingListError) {
                            <agpr-form-message
                                id="mailing_list_errors"
                                class="agpr-briefingError"
                            >
                                {{ 'Briefings.input.mailingLists.validation' | localize }}
                            </agpr-form-message>
                        }
                    </div>
                    <div class="agpr-inputGroup">
                        <agpr-email-chips
                            [id]="'recipientList'"
                            [(value)]="briefing.recipientList"
                            [placeholder]="'Briefings.input.recipients.placeholder' | localize"
                            clearAllChipsTooltip="Briefings.input.recipients.clearAllTooltip"
                            [errorKey]="'invalidEmailFormat' | localize"
                            header="Briefings.input.recipients"
                            (valueChange)="briefingChanged()"
                            ariaDescribedBy="recipient_errors"
                        ></agpr-email-chips>
                    </div>
                    <div class="agpr-briefingPublishingStep-divider"></div>
                    <div class="agpr-inputGroup">
                        <agpr-text-input
                            [id]="'fromTextInput'"
                            [maxLength]="maxInputTextLength"
                            [placeholder]="'Briefings.input.fromName.placeholder' | localize"
                            [label]="'Briefings.input.fromName'"
                            [(ngModel)]="briefing.fromName"
                            (ngModelChange)="briefingChanged()"
                            [bottomMargin]="false"
                            [ariaInvalid]="showErrors && (!briefing.fromName || briefing.fromName.trim() === '')"
                            ariaDescribedBy="fromName_errors"
                        ></agpr-text-input>
                    </div>
                    @if (showErrors && (!briefing.fromName || briefing.fromName.trim() === '')) {
                        <agpr-form-message
                            [id]="'fromName_errors'"
                            class="agpr-briefingError"
                        >
                            {{ 'Briefings.input.fromName.validation' | localize }}
                        </agpr-form-message>
                    }
                    <div class="agpr-inputGroup">
                        <agpr-text-input
                            [id]="'replyToTextInput'"
                            [maxLength]="maxInputTextLength"
                            [placeholder]="'Briefings.input.replyTo.placeholder' | localize"
                            [label]="'Briefings.input.replyTo'"
                            [(ngModel)]="briefing.replyTo"
                            (ngModelChange)="replyToChanged()"
                            (clickOutside)="setErrorList()"
                            (blur)="setErrorList()"
                            [attachOutsideOnClick]="true"
                            [bottomMargin]="false"
                            [ariaInvalid]="showErrors && (!briefing.replyTo || briefing.replyTo.trim() === '' || replyToInvalid)"
                            ariaDescribedBy="replyTo_errors"
                        ></agpr-text-input>
                    </div>
                    @if (showErrors && (!briefing.replyTo || briefing.replyTo.trim() === '' || replyToInvalid)) {
                        <ul
                            id="replyTo_errors"
                            class="agpr-briefingError"
                        >
                            @if (!briefing.replyTo || briefing.replyTo.trim() === '') {
                                <li>
                                    <agpr-form-message>
                                        {{ 'Briefings.input.replyTo.validation' | localize }}
                                    </agpr-form-message>
                                </li>
                            }

                            @if (replyToInvalid) {
                                <li>
                                    <agpr-form-message>
                                        {{ 'invalidEmailFormat' | localize }}
                                    </agpr-form-message>
                                </li>
                            }
                        </ul>
                    }
                    <div class="agpr-inputGroup">
                        <agpr-textarea-input
                            id="inviteMessage"
                            label="Briefings.input.inviteMessage"
                            maxLength="2048"
                            [rows]="4"
                            [placeholder]="'Briefings.input.inviteMessage.placeholder'"
                            [(ngModel)]="briefing.inviteMessage"
                            (ngModelChange)="briefingChanged()"
                            [resize]="resizeDirectionEnum.none"
                        ></agpr-textarea-input>
                    </div>
                    <agpr-canvas-email-style
                        [id]="id"
                        [initialDesignType]="initialEmailDesignType"
                        [onlineBriefingInviteStyle]="briefing.onlineBriefingInviteStyle"
                        [brandStyle]="brandStyle"
                        (onlineBriefingInviteStyleChange)="onlineBriefingInviteStyleChanged($event)"
                        [brandId]="briefing.canvasPreview?.brand?.id"
                        [briefingId]="briefing.id"
                    ></agpr-canvas-email-style>
                    <div class="agpr-briefingPublishingStep-previewEmail">
                        <agpr-button
                            [id]="id + '_previewEmail'"
                            class="agpr-briefingPublishingStep-previewEmail--button"
                            [style]="buttonTypes.tertiary"
                            label="Briefings.publishingStep.previewEmail.button"
                            (click)="openEmailPreview()"
                        >
                        </agpr-button>
                    </div>
                </div>
            }
        </div>
    }
}
@if (!briefing?.selectedDeliveryOption?.email && !briefing?.selectedDeliveryOption?.rssFeed && briefing.deliveryMethod === deliveryMethods.EMAIL) {
    <div class="agpr-briefingPublishingStep-deliveryOptionError">
        <agpr-form-message
            id="deliveryOption_error"
            class="agpr-briefingError"
        >
            {{ 'Briefings.deliveryOptions.validation' | localize }}
        </agpr-form-message>
    </div>
}

<ng-template #reservedUrlTemplate>
    <div>
        <h5 class="agpr-briefingPublishingStep-reservedUrl-title">{{ 'Briefings.sidebar.headingReservedURL' | localize }}</h5>
        <div class="agpr-briefingPublishingStep-reservedUrl-details">
            @if (reservedUrl && !briefing.sendAt.recurring) {
                @if (draftPublished) {
                    <a
                        [href]="reservedUrl"
                        class="agpr-briefingPublishingStep-reservedUrl-link"
                        target="_blank"
                    >
                        {{ reservedUrl }}
                    </a>
                } @else {
                    <span class="agpr-briefingPublishingStep-reservedUrl-text">
                        {{ reservedUrl }}
                    </span>
                }
            }

            @if (!reservedUrl && !briefing.sendAt.recurring) {
                <span>
                    {{ 'Briefings.reservedUrl.noUrlAvailable' | localize }}
                </span>
            }
            @if (briefing.sendAt.recurring) {
                <span>
                    {{ 'Briefings.reservedUrl.noRecurringUrl' | localize }}
                </span>
            }
            @if (!briefing.sendAt.recurring && reservedUrl) {
                <agpr-button
                    class="agpr-briefingPublishingStep-reservedUrl-urlCopyIcon"
                    [style]="buttonTypes.icon"
                    icon="fa-kit-duotone fa-agpr-copy"
                    tooltip="Reports.sharedReports.rhp.copyUrl"
                    tooltipPosition="top"
                    (click)="copyUrl($event, reservedUrl)"
                ></agpr-button>
            }
        </div>
        @if (!briefing.sendAt.recurring && reservedUrl) {
            <div
                class="agpr-briefingPublishingStep-reservedUrl-actions"
            >
                <agpr-button
                    [id]="id + '_briefingPublishDraft'"
                    [label]="draftPublished ? 'Briefings.reservedUrl.updateDraft' : 'Briefings.reservedUrl.createDraft'"
                    [style]="buttonTypes.tertiary"
                    [loading]="publishDraftInProgress"
                    (click)="publishDraft.emit()"
                ></agpr-button>
            </div>
        }
    </div>
</ng-template>

<ng-template #digestOptionTemplate>
    <div class="agpr-briefingPublishingStep-optionHeader">
        <agpr-checkbox
            [id]="'briefing_deliveryOptions_digest'"
            [(ngModel)]="briefing.selectedDeliveryOption.digest"
            [binary]="true"
            (onChange)="deliveryOptionChanged($event, deliveryOptionsEnum.digest)"
            ariaDescribedBy="deliveryOption_error"
        ></agpr-checkbox>
        <span
            class="fa-duotone fa-regular fa-books agpr-briefingPublishingStep-optionHeader-icon"
        ></span>
        <h4 class="agpr-briefingPublishingStep-optionHeader-title">
            {{ 'Briefings.deliveryOptions.digest' | localize }}
        </h4>
    </div>
    @if (!briefing.selectedDeliveryOption.digest) {
        <div class="agpr-briefingPublishingStep-optionDescription">
            {{ 'Briefings.deliveryOptions.digest.description' | localize }}
        </div>
    } @else {
        <div class="agpr-briefingPublishingStep-optionInputs">
            <agpr-digest-picker
                [id]="'digestPicker'"
                [(ngModel)]="briefing.digests"
                (change)="briefingChanged()"
                (ngModelChange)="briefingChanged()"
            ></agpr-digest-picker>
        </div>
    }
</ng-template>

<ng-template #rssFeedOptionTemplate>
    <div class="agpr-briefingPublishingStep-optionHeader">
        <agpr-checkbox
            [id]="'briefing_deliveryOptions_rss'"
            [(ngModel)]="briefing.selectedDeliveryOption.rssFeed"
            [binary]="true"
            (onChange)="deliveryOptionChanged($event, deliveryOptionsEnum.rssFeed)"
            ariaDescribedBy="deliveryOption_error"
        ></agpr-checkbox>
        <span
            class="fa-regular fa-duotone fa-rss agpr-briefingPublishingStep-optionHeader-icon"
        ></span>
        <h4 class="agpr-briefingPublishingStep-optionHeader-title">
            {{ 'Briefings.deliveryOptions.rssFeed' | localize }}
            <span
                id="briefing_deliveryOptions_rss_checkboxInfo"
                class="fa-regular fa-circle-info agpr-briefingPublishingStep-optionHeader-info"
                [agprTooltip]="'Briefings.deliveryOptions.rssFeed.tooltip'">
            </span>
        </h4>
    </div>
    @if (!briefing.selectedDeliveryOption.rssFeed) {
        <div class="agpr-briefingPublishingStep-optionDescription">
            {{ 'Briefings.deliveryOptions.rssFeed.description' | localize }}
        </div>
    } @else {
        <div class="agpr-briefingPublishingStep-optionInputs">
            <agpr-rss-feed-picker
                [id]="'rssFeedPicker'"
                [(ngModel)]="briefing.feeds"
                (change)="briefingChanged()"
                [isRssFeedMissing]="!briefing.feeds || (briefing.feeds?.length === 0)"
            ></agpr-rss-feed-picker>
        </div>
    }
</ng-template>